import {gsap} from "../LibrariesImport";

export default class DataAppearOnScroll {
	constructor() {
		const items = document.querySelectorAll("[data-aos]");

		items.forEach((item) => {

            const animation = item.dataset.aos;
            if (!animation) {
                console.log("no animation set");
                return;
            }
            const delay   = parseFloat(item.dataset.aosDelay ?? 0);
            const duration = parseFloat(item.dataset.aosDuration ?? 1);
            const start = item.dataset.aosStart ?? "top 90%";

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: item,
					start: start,
                    invalidateOnRefresh: true,
                    toggleActions: "play none none none",
				},
			});

            timeline.addLabel("start");

            if (animation === "fade-up") {
                timeline.to(item, {
                    autoAlpha: 1,
                    y: 0,
                    duration: duration,
                    overwrite: true,
                    immediateRender: false,
                }, `start+=${delay}`);
            }

            if (animation === "opacity") {
               timeline.to(item, {
                   autoAlpha: 1,
                   duration: duration,
                   overwrite: true,
                   immediateRender: false,
               }, `start+=${delay}`);
            }



			// Animation vide avec un délai pour appliquer la classe "appeared"
			// timeline.to(item, {
			// 	delay: parseFloat(delay),
			// 	duration: 0,
			// 	onComplete: () => item.classList.add("appeared")
			// });
		});
	}
}
